import type { ReactNode } from 'react';
import type { AnamneseType } from './anamneseType';

export function AnamneseWrapper(props: { anamneseType: AnamneseType; children: ReactNode }) {
    return <div className={`anamnese ${props.anamneseType}-anamnese`}>{props.children}</div>;
}
